<template>
  <div class="center--bottom" id="centerButtom"></div>
</template>

<script>
import { querytzhsqfx } from '@/api/modules/dataView.js'
export default {
  name: 'LeftChart3',
  props: {
    date: {
      type: Object,
      default: () => {
        return {
          startdate: '',
          enddate: '',
        }
      },
    },
  },
  data() {
    return {
      chart: null,
    }
  },
  mounted() {
    this.getData()
  },
  methods: {
    async getData() {
      var chartDom = document.getElementById('centerButtom')
      this.chart = this.$echarts.init(chartDom)
      const apiData = await querytzhsqfx(this.date)
      let xDatas = []
      let chartsDatas = []
      apiData.forEach(item => {
        xDatas.push(item.assets_type || '其他')
        chartsDatas.push(item.hxcs_tzhsqyq || 0)
      })
      var option

      option = {
        title: {
          text: '投资回收期分析',
          textStyle: {
            color: '#fff',
          },
        },
        tooltip: {
          axisPointer: {
            type: 'shadow',
          },
        },
        grid: {
          top: 80,
          bottom: 40,
        },
        xAxis: {
          type: 'category',
          axisLabel: {
            color: '#fff',
          },
          data: xDatas,
        },
        yAxis: {
          type: 'value',
          axisLabel: {
            color: '#fff',
          },
        },
        series: [
          {
            data: chartsDatas,
            type: 'bar',
          },
        ],
      }

      option && this.chart.setOption(option)
    },
  },
}
</script>

<style lang="scss">
.center--bottom {
  width: 100%;
  height: 40%;
}
</style>
